/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { apiCall } from './api'

export const CHANGE_CURATOR_PASSWORD = createAsyncAction(
  'CHANGE_CURATOR_PASSWORD'
)
export const changeCuratorPassword = password =>
  apiCall({
    method: 'put',
    endpoint: '/curator/change-password',
    query: {
      newPassword: password,
    },
    types: CHANGE_CURATOR_PASSWORD,
  })

export const CHANGE_ARTIST_PASSWORD = createAsyncAction(
  'CHANGE_ARTIST_PASSWORD'
)
export const changeArtistPassword = password =>
  apiCall({
    method: 'put',
    endpoint: '/artist/change-password',
    query: {
      newPassword: password,
    },
    types: CHANGE_ARTIST_PASSWORD,
  })

export const CHANGE_PAYPAL = createAsyncAction('CHANGE_PAYPAL')
export const changePaypal = email =>
  apiCall({
    method: 'put',
    endpoint: '/curator/paypal',
    query: {
      paypal_email: email,
    },
    types: CHANGE_PAYPAL,
  })

export const CHANGE_EMAIL = createAsyncAction('CHANGE_EMAIL')
export const changeEmail = (email, callback) =>
  apiCall({
    method: 'put',
    endpoint: '/user/email',
    query: {
      email,
    },
    types: CHANGE_EMAIL,
    callback,
  })
